import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
export var ToggleInput = function ToggleInput(_ref) {
  var qaid = _ref.qaid,
      className = _ref.className,
      leftLabel = _ref.leftLabel,
      rightLabel = _ref.rightLabel,
      leftValue = _ref.leftValue,
      rightValue = _ref.rightValue,
      value = _ref.value,
      onClick = _ref.onClick,
      disabled = _ref.disabled;
  var mainClassName = cx('ToggleInput', className);
  var left = false;
  if (leftValue === value) left = true;
  var toggleClassName = cx('ToggleInput-toggle', {
    'ToggleInput-toggle-left': left,
    'ToggleInput-toggle-right': !left
  });
  var labelLeftClassName = cx('ToggleInput-label', {
    'ToggleInput-label-enabled': left && !disabled
  });
  var labelRightClassName = cx('ToggleInput-label', {
    'ToggleInput-label-enabled': !left && !disabled
  });
  var toggleBgClassName = cx('ToggleInput-toggle-bg', {
    'ToggleInput-toggle-bg-disabled': disabled
  });
  var toggledValue = leftValue;
  if (leftValue === value) toggledValue = rightValue;

  var onClickLeftLabel = function onClickLeftLabel() {
    if (!disabled) onClick(leftValue);
  };

  var onClickRightLabel = function onClickRightLabel() {
    if (!disabled) onClick(rightValue);
  };

  var onClickToggle = function onClickToggle() {
    if (!disabled) onClick(toggledValue);
  };

  return React.createElement("div", {
    id: qaid,
    className: mainClassName
  }, React.createElement("div", {
    className: labelLeftClassName,
    onClick: onClickLeftLabel
  }, leftLabel), React.createElement("div", {
    className: toggleBgClassName,
    onClick: onClickToggle
  }, React.createElement("div", {
    className: toggleClassName
  })), React.createElement("div", {
    className: labelRightClassName,
    onClick: onClickRightLabel
  }, rightLabel));
};
ToggleInput.displayName = 'ToggleInput';
ToggleInput.propTypes = {
  leftLabel: PropTypes.string,
  rightLabel: PropTypes.string,
  leftValue: PropTypes.any.isRequired,
  rightValue: PropTypes.any.isRequired,
  qaid: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.any.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};
export default ToggleInput;